import {createContext} from "react";

export const StockItemsContext = createContext({});
